export default __webpack_public_path__ + "static/media/assignment_return.1f0dc8cb.svg";